module.exports = __webpack_public_path__ + "img/RS4021xs+.2924de31.png";